import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';

export class Kanton extends BaseModel {
    // properties
    id: number | null = null;
    bezeichnung: string | null = null;
    kuerzel: string | null = null;
    mandant: boolean | null = null;

    getClassName(): string {
        return 'Kanton';
    }
}

export class KantonCollection extends BaseCollection<Kanton> {
    protected modelCls = Kanton;

    public getModelClassName(): string {
        return 'Kanton';
    }
}

let _globalMandantKantonCollection: KantonCollection | null = null;

/**
 * global (single instance) collection: To be used where a global, shared instance can be used.
 * Note that this collection MUST NOT be filered / ordered on other places, as it is a shared instance!
 * @returns
 */
export function globalMandantKantonCollection(): KantonCollection {
    if (!_globalMandantKantonCollection) {
        const coll = new KantonCollection();
        coll.setQueryParams({
            sort: [
                {
                    property: 'bezeichnung',
                    direction: 'asc',
                },
                {
                    property: 'id',
                    direction: 'asc',
                },
            ],
            filter: [
                {
                    id: 'mandant',
                    property: 'mandant',
                    value: true,
                    operator: 'IS'
                }
            ]
        });
        coll.query();
        _globalMandantKantonCollection = coll;
    }
    return _globalMandantKantonCollection;
}


let _globalKantonCollection: KantonCollection | null = null;
/**
 * global (single instance) collection: To be used where a global, shared instance can be used.
 * Note that this collection MUST NOT be filered / ordered on other places, as it is a shared instance!
 * @returns
 */
export function globalKantonCollection(): KantonCollection {
    if (!_globalKantonCollection) {
        const coll = new KantonCollection();
        coll.setQueryParams({
            sort: [
                {
                    property: 'bezeichnung',
                    direction: 'asc',
                },
                {
                    property: 'id',
                    direction: 'asc',
                },
            ],
        });
        coll.query();
        _globalKantonCollection = coll;
    }
    return _globalKantonCollection;
}
